import { Box, Typography } from '@mui/material'

import { Button } from '@/components/ui/button'

interface Props {
  onSetUp: VoidFunction
}

const TEXT =
  'This change needs two-step verification, and your account does not have a method yet. Set one up, then make the change again.'

// Nothing to prove here, so the step-up dialog hands off to the two-step setup instead of enrolling behind it.
export function StepUpEnrollmentRequired({ onSetUp }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="body2">{TEXT}</Typography>
      <Button variant="contained" size="large" fullWidth onClick={onSetUp}>
        Set up two-step verification
      </Button>
    </Box>
  )
}
